export default {
  events: {
    detailTitle: "Detalle del evento",
    close: "Cerrar",
    product: "Producto",
    ingredientLab: "P. activo · laboratorio",
    whatHappened: "Qué ha pasado",
    whyItMatters: "Por qué importa",
    source: "Fuente",
    openDocument: "documento de origen",
    confirmedBy: "confirmado por {n} fuentes",
    published: "Publicado",
    detected: "Detectado",
    relationOwn: "Producto propio",
    relationCompetitor: "Competencia",
    relationMarket: "Mercado",
    colDetail: "Detalle",
    colBlock: "Bloque",
    nregistro: "Nº de registro",
    sourceSince: "vigilada desde el {date}",
    openEvent: "Ver el detalle del evento",
  },
};
